import React, { useCallback } from 'react';
import { Button, notification } from 'antd';
import { CopyIcon } from '@assets/icons/content/Copy';
import { copy } from './utils';

export interface CopyButtonProps {
  text: string;
}

export const CopyButton: React.FC<CopyButtonProps> = ({ text }) => {
  const handleClick = useCallback(async () => {
    try {
      await copy(text);

      notification.success({ title: 'Контент успешно скопирован' });
    } catch (e) {
      notification.error({ title: 'Не удалось скопировать контент' });
    }
  }, [text]);

  return (
    <Button
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
      }}
      icon={<CopyIcon width={16} height={16} />}
      onClick={handleClick}
    />
  );
};
